import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'antd';
import FilterPosition from './FilterPosition';
import FilterCounty from './FilterCounty';
import FilterOffer from './FilterOffer';
import FilterRange from './FilterRange';
import FilterZMax from './FilterZMax';
import FilterYear from './FilterYear';
import FilterStatus from './FilterStatus';

import getConferenceFile from '../../constants/getConferenceFile';

class EditFilterModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: '',
      pos: [],
      offers: {},
      counties: {},
      years: [],
      conferences: [],
      confLoaded: false,
    };
  }

  componentWillUpdate(nextState, nextProps) {
    if (typeof nextState.resetModal !== 'undefined' && nextState.resetModal === true) {
      this.state.counties = {};
      this.state.offers = {};
    }
  }

  handlePosChange(tag, checked) {
    let newPos = this.state.pos;

    if (checked) {
      if (tag === 'All') {
        newPos = ['All'];
      } else if (newPos[0] === 'All') {
        newPos = [tag];
      } else {
        newPos.push(tag);
      }
    } else {
      newPos = newPos.length > 1 ? newPos.filter((pos) => pos != tag) : ['All'];
    }

    this.setState({ pos: newPos });
  }

  /**
   * Adds county to filter
   *
   * @param {Object} newCounties in list format ['AL', 'Some County']
   * @memberof EditFilterModal
   */
  handleCountyChange(newCounties) {
    //perform state update
    this.setState({
      counties: newCounties,
    });
  }

  removeOffer(tag) {
    // initialize necessary variables
    let newOffers = JSON.parse(JSON.stringify(this.state.offers));
    let conferenceSchool = tag.split(': ');

    // perform deletion
    if (newOffers[conferenceSchool[0]].length === 1) {
      delete newOffers[conferenceSchool[0]];
    } else {
      newOffers[conferenceSchool[0]] = newOffers[conferenceSchool[0]].filter((school) => {
        return school !== conferenceSchool[1];
      });
    }

    //perform state update
    this.setState({
      offers: newOffers,
    });
  }

  handleOfferChange(val) {
    //perform state update
    this.setState({
      offers: val,
    });
  }

  onRangeChange(value) {
    this.setState({ sliderRange: value });
  }

  onMinZMaxChange(value) {
    this.setState({ minZMax: value });
  }

  handleYearsChange(tag, checked) {
    let newYears = JSON.parse(JSON.stringify(this.state.years));

    if (checked) {
      if (tag === 'All') {
        newYears = ['All'];
      } else if (newYears[0] === 'All') {
        newYears = [tag];
      } else {
        newYears.push(tag);
      }
    } else {
      newYears = newYears.length > 1 ? newYears.filter((year) => year != tag) : ['All'];
    }

    newYears.sort();
    this.setState({ years: newYears });
  }

  handleStatusChange(tag, checked) {
    let newStatus = JSON.parse(JSON.stringify(this.state.status));

    if (checked) {
      if (tag === 'All') {
        newStatus = ['All'];
      } else if (newStatus[0] === 'All') {
        newStatus = [tag];
      } else {
        newStatus.push(tag);
      }
    } else {
      newStatus = newStatus.length > 1 ? newStatus.filter((status) => status != tag) : ['All'];
    }

    this.setState({ status: newStatus });
  }

  isEquivalent(a, b) {
    const aProps = Object.getOwnPropertyNames(a);
    const bProps = Object.getOwnPropertyNames(b);

    if (aProps.length != bProps.length) {
      return false;
    }

    for (let i = 0; i < aProps.length; i++) {
      const propName = aProps[i];

      if (JSON.stringify(a[propName]) !== JSON.stringify(b[propName])) {
        return false;
      }
    }

    return true;
  }

  handleSave() {
    this.props.handleOk(this.state, this.props.filter.key);
  }

  handleCancel() {
    this.props.handleCancel(this.state, this.isEquivalent);
  }

  componentWillMount() {
    // console.log(this.props)
    // 4th state variable depends on the type of filter
    if (this.props.type === 'POI') {
      this.setState({ offers: [], sliderRange: 100 });
    } else if (this.props.type === 'RatingBump') {
      this.setState({ sliderRange: [0, 100] });
    } else if (this.props.type === 'TrackedProspects') {
      this.setState({ status: [] });
    }

    // if redirected (i.e. Zcruit User)
    if (
      this.props.redirected &&
      localStorage.zcruitLite === 'false' &&
      (this.props.type === 'POI' || this.props.type === 'RatingBump')
    ) {
      this.setState({ minZMax: 0 });
    }

    if (this.state.confLoaded === false) {
      // getConferenceFile()
      //   .then((json) => {
      //     this.setState({
      //       conferences: JSON.parse(JSON.stringify(json)),
      //       confLoaded: true
      //     });
      //   });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.action !== '') {
      let newState = {
        title: nextProps.action + ' Filter',
        pos: ['All'],
        years: ['All'],
        counties: {},
      };

      if (nextProps.action === 'Edit') {
        newState.pos = nextProps.filter.pos.split(',');
        // newState.states = nextProps.filter.state.split(',')
        newState.years = nextProps.filter.years.split(',');
        newState.counties = nextProps.filter.countyObj;

        if (nextProps.type === 'POI') {
          newState['offers'] = nextProps.filter.offersObj;
          newState['sliderRange'] = nextProps.filter.range
            .split('-')
            .map((numb) => parseInt(numb))[1];
        } else if (nextProps.type === 'RatingBump') {
          newState['sliderRange'] = nextProps.filter.range.split('-').map((numb) => parseInt(numb));
        } else if (nextProps.type === 'TrackedProspects') {
          newState['status'] = nextProps.filter.status.split(',');
        }
      } else if (nextProps.type === 'POI') {
        newState['offers'] = {};
        newState['sliderRange'] = 100;
      } else if (nextProps.type === 'RatingBump') {
        newState['sliderRange'] = [0, 100];
      } else if (nextProps.type === 'TrackedProspects') {
        newState['status'] = ['All'];
      }

      // For Zcruit users only
      if (
        nextProps.redirected &&
        localStorage.zcruitLite === 'false' &&
        (nextProps.type === 'POI' || nextProps.type === 'RatingBump')
      ) {
        if (nextProps.action === 'Edit') {
          newState['minZMax'] = nextProps.filter.minZMax;
        } else {
          newState['minZMax'] = 0;
        }
      }
      this.setState(newState);
    }
  }

  render() {
    return (
      <Modal
        title={this.state.title}
        visible={this.props.visible}
        onOk={this.handleSave.bind(this)}
        onCancel={this.handleCancel.bind(this)}>
        <FilterPosition pos={this.state.pos} handlePosChange={this.handlePosChange.bind(this)} />

        <FilterCounty
          states={this.props.states}
          value={this.state.counties}
          handleChange={this.handleCountyChange.bind(this)}
        />

        {this.props.type === 'POI' && (
          <FilterOffer
            conferences={this.props.conferences}
            value={this.state.offers}
            handleChange={this.handleOfferChange.bind(this)}
          />
        )}
        {((this.props.type === 'POI' &&
          (!this.props.redirected || localStorage.zcruitLite === 'true')) ||
          this.props.type === 'RatingBump') && (
          <FilterRange
            visible={this.props.visible}
            filterType={this.props.type}
            range={this.state.sliderRange}
            onAfterChange={this.onRangeChange.bind(this)}
          />
        )}
        <FilterYear
          years={this.state.years}
          handleYearsChange={this.handleYearsChange.bind(this)}
        />
        {this.props.type === 'TrackedProspects' && true && (
          <FilterStatus
            status={this.state.status}
            handleStatusChange={this.handleStatusChange.bind(this)}
          />
        )}
      </Modal>
    );
  }
}

function mapStoreToProps(storeState) {
  return {
    redirected: storeState.main.redirected,
    states: storeState.main.states,
    conferences: storeState.main.conferences,
  };
}

export default connect(mapStoreToProps)(EditFilterModal);



// WEBPACK FOOTER //
// ./src/components/prospectIdentification/EditModal.js